export function notifyDone() {
  try { navigator.vibrate?.([200, 100, 200, 100, 300]); } catch {}
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    [830, 1050].forEach((freq, i) => {
      setTimeout(() => {
        const o = ctx.createOscillator(), g = ctx.createGain();
        o.connect(g); g.connect(ctx.destination);
        o.frequency.value = freq; o.type = "sine"; g.gain.value = 0.3;
        o.start(); o.stop(ctx.currentTime + 0.18);
      }, i * 220);
    });
  } catch {}
  if (typeof Notification !== "undefined" && Notification.permission === "granted") {
    try { new Notification("Rest complete ✓", { body: "Time for your next set!" }); } catch {}
  }
}

export function requestNotifPermission() {
  if (typeof Notification !== "undefined" && Notification.permission === "default") {
    Notification.requestPermission();
  }
}

// Register service worker for background notifications
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').catch(() => {});
  });
  // Listen for timer done message from SW (when app was backgrounded)
  navigator.serviceWorker.addEventListener('message', e => {
    if (e.data?.type === 'TIMER_DONE') {
      notifyDone();
    }
  });
}

export function sendSwMessage(msg) {
  if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
    navigator.serviceWorker.controller.postMessage(msg);
  }
}
